export default __webpack_public_path__ + "static/media/chatIcon.5398c6ca.svg";